import { Block, component } from '../../../scripts/core/Component'
import { Input } from '../input/index'
import { Textarea } from '../textarea/index'
import { Select } from '../select/index'
import { Button } from '../button/index'

@component('field')
class Field extends Block {

  static inputTypeList = [Input, Textarea, Select, Button]
  
  constructor (context) {
    super(context)

    this.input = this.initInput()
  }
  
  initInput() {
    for(let index = 0; index < Field.inputTypeList.length; index++) {
      const Input = Field.inputTypeList[index]
            
      let list = this.list(Input)
      if(list.length) {
        return list.shift()
      }
    }
    
    return null
  }

  displayError() {
    
  }
  
  validate() {
    let validation = this.input.validate()
    if(!validation.result) {
      this.displayError(validation.message)
      
      return false;
    }
    
    return true
  }
}

export {
  Field
}


// WEBPACK FOOTER //
// ./components/ui/field/index.js